export const PROFILES_LIST_URL = '/profiles/';
export const ROOM_LIST_HD_URL = '/rooms/hd/';
export const ROOM_LIST_NEO_URL = '/rooms/neo/';
export const PERSONAL_ROOM_LIST_URL = '/rooms/personal/';
export const REAL_GIFT_LIST_URL = '/last_real_gifts/';
export const LAST_WALL_MATERIALS_URL = '/last_wall_materials/';
export const LAST_BOBSTORE_SUBMISSIONS_URL = '/last_bobstore_submissions/';
export const LAST_FILMS_AMATEURS_URL = '/last_films_amateurs/';
export const LAST_VIRTUAL_GIFTS_URL = '/last_virtual_gifts/';
export const MESSAGE_OF_DAY_URL = '/mod/';
export const FAVOURITES_URL = '/favourites/';
export const GENEROUS_USERS_URL = '/generous-users/';
export const CURRENT_USER_URL = '/member/';
export const MEMBER_PERSONAL_ROOM_URL = '/member/room/get/';
export const CREATE_MEMBER_PERSONAL_ROOM_URL = '/member/room/create/';
export const UPDATE_MEMBER_PERSONAL_ROOM_URL = '/member/room/update/';
export const DELETE_MEMBER_PERSONAL_ROOM_URL = '/member/room/delete/';
export const LOGIN_URL = '/login/';
export const LOGOUT_URL = '/logout/';
export const CHANGE_PASSWORD_URL = '/member/change/password/';
export const CHANGE_EMAIL_URL = '/member/change/email/';
export const CHANGE_PHONE_URL = '/member/change/phone/';
export const UPLOAD_MEMBER_PHOTO_URL = '/member/photo/upload/';
export const UPLOAD_AVATAR_URL = '/member/upload_avatar/';
export const UPLOAD_MEMBER_FILMAMATEUR_URL = '/member/amateur_film/upload/';
export const SAVE_MEMBER_FILMAMATEUR_URL = '/member/amateur_film/save/';
export const DELETE_MEMBER_FILMAMATEUR_URL = '/member/amateur_film/delete/';


// WEBPACK FOOTER //
// ./src/backend-helpers/constants.js